import type { GatewayManifestEntry } from '../payment-gateways/core/types';

/**
 * The single source of truth for "which gateways exist and where do they
 * run." Adding a gateway means adding one entry here plus one adapter
 * folder under src/payment-gateways/gateways/ — nothing else in the app
 * changes (see SKILLS.md's Recipe 1). The query functions that read this
 * live in src/payment-gateways/core/registry.ts; this file is data only,
 * so a routing change is a one-file edit with no logic to re-read.
 *
 * `load` is the code-splitting boundary: GatewayFactory only pulls a
 * gateway's JS in once it's actually selected for the current country, so
 * India never downloads 2C2P's code and vice versa. Keep the import path
 * inline and literal — Vite needs to see it statically to split the chunk.
 */
export const GATEWAY_MANIFEST: GatewayManifestEntry[] = [
  {
    id: 'razorpay',
    countries: ['IN'],
    label: 'Razorpay',
    default: true,
    load: () =>
      import('../payment-gateways/gateways/razorpay/RazorpayAdapter').then(
        (m) => ({ default: m.razorpayAdapter })
      ),
  },
  {
    id: '2c2p',
    countries: ['TH'],
    label: '2C2P',
    default: true,
    load: () =>
      import('../payment-gateways/gateways/2c2p/TwoC2PAdapter').then((m) => ({
        default: m.twoC2PAdapter,
      })),
  },
  {
    id: 'paycenter',
    countries: ['LK'],
    label: 'PayCenter',
    default: true,
    load: () =>
      import('../payment-gateways/gateways/paycenter/PayCenterAdapter').then(
        (m) => ({ default: m.payCenterAdapter })
      ),
  },
];
